import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { provideTrackingService } from '@usheru-hff/sdk/tracking';
import { environment } from '../environments/environment';
import { ENVIRONMENT } from '@environment';
import { HttpClientModule } from '@angular/common/http';
import { StripeModule } from 'stripe-angular';

import { provideAuthResource, provideBaseServices, provideCacheInterceptor } from '@usheru-hff/shared/utils-providers';
import { AuthenticationDomainModule } from '@usheru-hff/authentication/domain';
import { BrandedPageUiBrandedTemplatesModule } from '@usheru-hff/branded-page/ui-branded-templates';
import { HffCommonUiUsheruLogoModule } from '@usheru-hff/hff-common/ui-usheru-logo';

import { ProductionsComponent } from './catalog/productions/productions.component';

import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';
import { providerRouteReuseStrategy } from '@usheru-hff/hff-common/util-routes';
import { TemplatesService } from '@usheru-hff/shared/utils';
import { RouterModule } from '@angular/router';
import { FeatureFilmInteractionsComponent } from '@usheru-hff/movie-detail/feature-film-interactions';
import { FeatureFilmInteractionsToken } from '@usheru-hff/shared/tokens';

const stripekey = environment.stripe;

@NgModule({
  declarations: [ProductionsComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    StripeModule.forRoot(stripekey),
    RouterModule,
    HttpClientModule,
    AuthenticationDomainModule,
    HffCommonUiUsheruLogoModule,
    SharedUtilsImageModule
  ],

  providers: [
    {
      provide: ENVIRONMENT,
      useValue: environment
    },
    {
      provide: FeatureFilmInteractionsToken,
      useClass: FeatureFilmInteractionsComponent
    },
    TemplatesService,
    provideAuthResource(environment),
    provideBaseServices(environment),
    provideTrackingService(),
    provideCacheInterceptor(),
    providerRouteReuseStrategy()
  ],
  bootstrap: []
})
export class AppModule {}
